import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {UtilConfig} from "../../../../../autenticacion/servicios/UtilConfig";
import {Router} from "@angular/router";
import {EmisorService} from "../recursos/servicios/emisor.service";

declare var swal: any;
declare const $: any;

@Component({
    selector: 'cmp-card-emisor',
    templateUrl: './view/card-emisor.component.html',
    styleUrls: ['./css/card-emisor.component.scss']
})
export class CardEmisorComponent implements OnInit, OnChanges {

    origenCRUD = "Emisor";

    authorities = {
        ROLE_EMISOR_LISTAR: false,
        ROLE_EMISOR_CONSULTAR: false,
        ROLE_EMISOR_REGISTRAR: false,
        ROLE_EMISOR_MODIFICAR: false,
        ROLE_EMISOR_ELIMINAR: false,
        ROLE_EMISOR_ACTIVAR: false,
    };

    @Input() emisor;
    @Input() accion;

    constructor(private emisorService: EmisorService,
                private router: Router,
                private jwtUtil: UtilConfig) {
        // VERIFICA LOS PERMISOS DEL EMISOR LOGEADO
        this.authorities = jwtUtil.verificarAuthorities(this.authorities);
    }

    ngOnInit() {
    }

    ngOnChanges() {
        if (this.emisor.logo == null || this.emisor.logo == undefined) {
            this.emisor.logo = "data:image/PNG;base64,";
        } else {
            if (this.emisor.logo.indexOf("data:image/PNG;base64,") == -1)
                this.emisor.logo = "data:image/PNG;base64," + this.emisor.logo;
        }

        if (!this.emisor.goodReqCounter) {
            this.emisor.goodReqCounter = 0;
        }

        if (!this.emisor.failReqCounter) {
            this.emisor.failReqCounter = 0;
        }

    }


    abrirSelector() {
        $(".ui-fileupload input").click();
    }


}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/emisor/cmp-card-emisor/card-emisor.component.ts